import { render, staticRenderFns } from "./pSidebar.vue?vue&type=template&id=7f0be6a8"
import script from "./pSidebar.vue?vue&type=script&lang=js"
export * from "./pSidebar.vue?vue&type=script&lang=js"
import style0 from "./pSidebar.vue?vue&type=style&index=0&id=7f0be6a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports